import request from '@/utils/request'


//epmsa012Detail
export function epmsa330Detail(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa330/epmsa330Detail`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function getShipNoList() {
  return request({
    url: `/outsoucingBlockControl/epmsa330/getShipNoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' }    
  })
}

export function getLotNoList(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa330/getLotNoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function getUseShipNoList() {
  return request({
    url: `/outsoucingBlockControl/epmsa330/getUseShipNoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' }    
  })
}

export function getUseLotNoList(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa330/getUseLotNoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
